<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <h1>{{'STRATEGY.Inyova3a.modal.' + key + '.title' | translate}}</h1>
  <p>{{'STRATEGY.Inyova3a.modal.' + key + '.p' | translate}}</p>
</ion-content>
